import { NativeMidiInput } from "./NativeMidiInput";
import { IMidiInputArray } from "./IMidiInput";
import ISelectOption from "./view/common/ISelectOption";

/**
 * Array wrapper for NativeMidiInput objects, providing the same interface
 * as NormalizedMidiInputArray for compatibility with the settings store.
 */
export class NativeMidiInputArray extends Array<NativeMidiInput> implements IMidiInputArray {
  public getSelectOptions(): ISelectOption[] {
    const result = this.map((midiInput) => ({
      label: midiInput.getName(),
      value: midiInput.getId(),
    }));

    return result;
  }

  public toString(): string {
    let result = "[";
    result += this.map((midiInput) => midiInput.toString()).join(", ");
    result += "]";
    return result;
  }
}

